import { render, staticRenderFns } from "./couponLogo.vue?vue&type=template&id=678e1042&scoped=true&"
import script from "./couponLogo.vue?vue&type=script&lang=js&"
export * from "./couponLogo.vue?vue&type=script&lang=js&"
import style0 from "./couponLogo.vue?vue&type=style&index=0&id=678e1042&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678e1042",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/show/couponLogo.vue
// module id = null
// module chunks = 